import { render, staticRenderFns } from "./fb-post-03.vue?vue&type=template&id=49dc6842&scoped=true&"
import script from "./fb-post-03.vue?vue&type=script&lang=js&"
export * from "./fb-post-03.vue?vue&type=script&lang=js&"
import style0 from "./fb-post-03.vue?vue&type=style&index=0&id=49dc6842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc6842",
  null
  
)

export default component.exports